import { openUserCache } from "./openCache";

export const deleteData = async (dbName: string, id: string | IDBKeyRange) => {
	const db = await openUserCache();
	const store = db.transaction([dbName], "readwrite").objectStore(dbName);
	const req = store.delete(id);

	return new Promise((resolve, reject) => {
		req.onerror = reject;
		req.onsuccess = resolve;
	});
};

export const deleteAllData = async (dbName: string, startingId: string | number = "") => {
	const db = await openUserCache();
	const getAllKeys = db.transaction([dbName], "readwrite").objectStore(dbName).getAllKeys();

	return new Promise<void>((resolve, reject) => {
		getAllKeys.onerror = reject;
		getAllKeys.onsuccess = async () => {
			const promises = [];
			getAllKeys.result.forEach((key) => {
				if (!(key + "").startsWith(startingId + "")) {
					return;
				}

				promises.push(deleteData(dbName, key + ""));
			});

			await Promise.all(promises);

			resolve();
		};
	});
};
